"use strict";

exports.__esModule = true;
exports.AlertGrid = AlertGrid;
var _react = _interopRequireDefault(require("react"));
var _Report = require("../../Report/Report");
var _Report2 = require("../../Report");
var _AlertGridConfig = require("./AlertGridConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AlertGrid(props) {
  var width = props.width,
    height = props.height,
    style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_Report2.StandardReportDataProvider, null, /*#__PURE__*/_react["default"].createElement(_Report.Report, {
    config: _AlertGridConfig.config,
    width: width,
    height: height,
    style: style
  }));
}